import { ENTITY_TYPES } from '@sales-center/common'
import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'

export function useGetMainLabel(filterName: string, entityType?: ENTITY_TYPES) {
  const { t } = useTranslation()

  return useMemo(() => {
    switch (filterName) {
      case 'ownerId':
      case 'assignee': {
        return 'Owner'
      }
      case 'billToPostalCode': {
        return t('billToCode')
      }
      case 'campaignId': {
        return 'Campaign'
      }
      case 'closed': {
        return entityType == ENTITY_TYPES.Lead
          ? 'Lead Status'
          : 'Opportunity Status'
      }
      case 'createdBy': {
        return entityType == ENTITY_TYPES.Lead
          ? 'Lead Created By'
          : 'Opportunity Created By'
      }
      case 'createdDate': {
        if (entityType == ENTITY_TYPES.Lead) {
          return 'Lead Created Date'
        }
        if (entityType == ENTITY_TYPES.Opportunity) {
          return 'Opportunity Created Date'
        }
        return 'Created Date'
      }
      case 'disqualifiedDate': {
        return 'Disqualified Date'
      }
      case 'leadCreatedTime': {
        return 'Lead Created Date'
      }
      case 'divisionId': {
        return 'Division'
      }
      case 'initialValue': {
        return 'Initial Value'
      }
      case 'locationTypeId': {
        return 'Location Type'
      }
      case 'nextActionDate': {
        return 'Next Action Date'
      }
      case 'postalCode': {
        return t(!entityType ? 'postalCode' : 'serviceLocationCode')
      }
      case 'recurringValue': {
        return 'Recurring Value'
      }
      case 'salesFunnelId': {
        return 'Sales Funnel'
      }
      case 'salesFunnelStageId': {
        return 'Funnel Stages'
      }
      case 'salesTeamId': {
        return 'Sales Team'
      }
      case 'salesTeamIds':
        return 'Sales Teams'
      case 'services': {
        return 'Services'
      }
      case 'sourceId': {
        return 'Lead Source'
      }
      case 'totalLeadValue': {
        return 'Total Lead Value'
      }

      case 'createdTime': {
        return 'Date Submitted'
      }
      case 'userName': {
        return 'Submitted By'
      }
      case 'submittedBy': {
        return 'Submitted By'
      }

      case 'leadCreatedBy': {
        return 'Lead Created By'
      }
      case 'branchId': {
        return 'Branch'
      }
      case 'closedDate': {
        return 'Closed Date'
      }
      case 'expectedClosingDate': {
        return 'Expected Closing Date'
      }
      case 'totalValue': {
        return 'Total Value'
      }
      case 'soldServiceStatus': {
        return 'Funnel Stage'
      }
      case 'activityStatus': {
        return 'Activity Status'
      }
      case 'activityTypeId': {
        return 'Activity Type'
      }
      case 'dueDate':
        return 'Due Date'
      case 'startDate':
        return 'Start Date'
      case 'type':
        return 'Type'
      case 'importId':
        return 'Import Name'
      case 'targetPests':
        return 'Target Pests'
      case 'agreementStatuses':
        return 'Agreement Status'
      case 'hasPestPacLocation':
        return 'Has PestPac Location'
      case 'closedLost':
        return 'Closed/Lost'
      case 'knockStatusSettingId':
        return 'Knock Status'
      default: {
        return ''
      }
    }
  }, [filterName, entityType, t])
}
